export default __webpack_public_path__ + "static/jvc-osa-canada-logo-bbdec6641fcfa30fd09a2a2e354980b8.png";